import API from '@/constant/API';
import axiosInstance from '@/utils/axios';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import KYCPreForm from '../user/components/KYCPreForm';
import { replace, useNavigate } from 'react-router-dom';
import RouteConstant from '@/constant/RouteConstant';

function KYCIndex() {
  const navigate = useNavigate();
  const { user } = useSelector(state => state.user);

  useEffect(() => {
    // _initData();
  }, []);

  const _initData = async () => {
    const res = await axiosInstance.post(API.KYC_INFO);
  }

  const _onFormSave = async () => {
    navigate(RouteConstant.KYC_MAIN, {
      replace: true
    });
  }
  
  return (
    <KYCPreForm onSuccess={_onFormSave} />
  )
}

export default KYCIndex